import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ApiConfigInterceptor } from '@core/api/api.interceptor';
import { AiEngineApiInterceptor } from '@core/api/ai-engine-api.interceptor';
import { ApiService } from '@core/api/api.service';
import { ErrorHandlerModule } from '@core/errors/error-handler.module';
import { HttpMethod, NgEntityServiceGlobalConfig, NG_ENTITY_SERVICE_CONFIG } from '@datorama/akita-ng-entity-service';

@NgModule({
    declarations: [],
    exports: [], imports: [CommonModule, ErrorHandlerModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiConfigInterceptor,
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AiEngineApiInterceptor,
            multi: true,
        },
        {
            provide: NG_ENTITY_SERVICE_CONFIG,
            useValue: {
                baseUrl: '',
                httpMethods: {
                    PUT: HttpMethod.PATCH,
                },
            } as NgEntityServiceGlobalConfig,
        },
        ApiService,
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class ApiModule { }
